module.exports = {
      id: "spinner-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "sprite.b16108e5f95a8323b5a812454e446fa5.svg#spinner-usage",
      toString: function () {
        return this.url;
      }
    }